import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {Watch} from '@acng/frontend-relativity';

import {ctxVipPoints} from '../context/points.js';
import {animate} from '../../layout/service/animate-number.js';
import {compile} from '../service/template.js';

/**
 * @group DOM Attribute
 */
const ACHIEVEMENT_POINTS = 'data-vip-points';

AttributeSetup(ACHIEVEMENT_POINTS, (name) => {
  const watch = Watch(attributeSelector(name), ctxVipPoints);

  AttributeLink(name, (element) => watch(element, animate));

  return compile;
});
